import React from 'react';
import { Field, reduxForm } from 'redux-form';
import TextField from './TextField';
import { Grid, Button, Container, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { checkRut, formatoRut } from '../services/utils';

const useStyles = makeStyles({
    areaPaper: {
        padding: '10px 0',
        marginBottom: '20px',
        borderColor: 'rgba(0, 0, 0, 0.3)'
    }
});

const validate = (values = {}) => {
    const errors = {};
    const requiredFields = [
        'nombres',
        'rut',
        'apellidos'
    ];
    requiredFields.forEach((field) => {
        if (!values[field]) {
            errors[field] = 'Requerido';
        }
    });

    if (!checkRut(values.rut)) {
        errors.rut = 'Rut Inválido';
    }

    return errors;
};

let FormTrabajador = (props) => {
    const {
        handleSubmit,
        change,
        touch,
        pristine,
        reset,
        submitting,
        editar,
    } = props;
    const classes = useStyles();

    return (
        <Container>
            <form noValidate onSubmit={handleSubmit}>
                <Paper variant="outlined" className={classes.areaPaper}>
                    <Grid container>
                        <Grid item xs={12} lg={4}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '80%' }}
                                    type="text"
                                    name="rut"
                                    label="RUT"
                                    component={TextField}
                                    normalize={formatoRut}
                                    // props={{ disabled: editar}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '80%' }}
                                    type="text"
                                    name="nombres"
                                    label="Nombres"
                                    component={TextField}
                                    // props={{ disabled: (estadoRUT == 'existe' || estadoRUT == 'editarSucursal')}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <Grid container justify="center" alignItems="center">
                                <Field
                                    required
                                    style={{ width: '80%' }}
                                    type="text"
                                    name="apellidos"
                                    label="Apellidos"
                                    component={TextField}
                                    // props={{ disabled: (estadoRUT == 'existe' || estadoRUT == 'editarSucursal')}}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
                <Grid container style={{ marginTop: '15px' }} justify="center" alignItems="center">
                    <Button type="submit" variant="outlined" color="primary">
                        {editar ? 'Editar' : 'Agregar'}
                    </Button>
                </Grid>
            </form>
        </Container>
    )
}

FormTrabajador = reduxForm({
    form: 'trabajadorProveedor',
})(FormTrabajador);

export default connect((state, ownProps) => ({
    initialValues: {
        nombres: ownProps.editar ? ownProps.dataTrabajador.nombres : null,
        rut: ownProps.editar ? ownProps.dataTrabajador.rut : null,
        apellidos: ownProps.editar ? ownProps.dataTrabajador.apellidos : null
    },
    enableReinitialize: true,
    validate,
}))(FormTrabajador);